import React from 'react';
import PropTypes from 'prop-types';


const FeaturedBrands = function FeaturedBrandsComponent({ brands }) {
  return brands.map(brand => (
    <a
      href={brand.url}
      key={brand.name}
      className="homepage-category__brand"
      aria-label={`Shop ${brand.name}`}
    >
      <div className="homepage-category__brand__image">
        <img
          srcSet={brand.logo}
          src={brand.logo}
          alt=""
        />
        <span className="homepage-category__brand__title">
          {brand.name}
        </span>
      </div>
    </a>
  ));
};

export default FeaturedBrands;

FeaturedBrands.propTypes = {
  brands: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
  })),
};
